import {
  ForeignCurrencyCostRateCalculationType,
  VehicleJurisdiction,
  CommitmentType,
  CapitalContributionRule,
  ReportingPeriods,
} from 'further-types/lp/vehicle';

export const ForeignCurrencyCostRateCalculationLabels = {
  [ForeignCurrencyCostRateCalculationType.Average]: 'Average cost',
};

export const VehicleJurisdictionLabels = {
  [VehicleJurisdiction.CaymanIslands]: 'Cayman Islands',
  [VehicleJurisdiction.DelawareUS]: 'Delaware (US)',
  [VehicleJurisdiction.EnglandUK]: 'England (UK)',
  [VehicleJurisdiction.Guernsey]: 'Guernsey',
  [VehicleJurisdiction.HongKong]: 'Hong Kong',
  [VehicleJurisdiction.Ireland]: 'Ireland',
  [VehicleJurisdiction.Jersey]: 'Jersey',
  [VehicleJurisdiction.Luxembourg]: 'Luxembourg',
  [VehicleJurisdiction.Scotland]: 'Scotland',
  [VehicleJurisdiction.Singapore]: 'Singapore',
};

export const ReportingPeriodsLabels = {
  [ReportingPeriods.Quarterly]: 'Quarterly',
  [ReportingPeriods.HalfYearly]: 'Half yearly',
};

export const CommitmentTypeLabels = {
  [CommitmentType.CapitalOnly]: 'Capital only',
  [CommitmentType.LoanOnly]: 'Loan only',
  [CommitmentType.CapitalAndLoan]: 'Capital and loan',
};

export const CapitalContributionRuleLabels = {
  [CapitalContributionRule.FixedCommitmentPercentage]:
    'Fixed commitment percentage',
  [CapitalContributionRule.ProRataOfFixedPartnershipCapital]:
    'Pro rata of fixed partnership capital after GP/CP contribution',
  [CapitalContributionRule.Manual]: 'Manual',
};
